import React from "react";
import {
  Header,
  LogoContainer,
  MenuContainer,
  NavItem,
  LoginButtonHeader,
} from "./index.styled";
import { CustomButton } from "../buttons/index.styled";
import logo from "../../assets/images/landing-logo.svg";
import { env } from "../../.env";

const LandingHeader = () => {
  const menuItems = [
    { id: 1, content: "کاربردها", path: "usages" },
    { id: 2, content: "ویژگی ها", path: "features" },
    { id: 3, content: "مشتریان", path: "customers" },
    { id: 4, content: "تماس با ما", path: "contacts" },
  ];

  return (
    <Header className="container">
      <LogoContainer>
        <img src={logo} alt="logo" />
      </LogoContainer>
      <MenuContainer>
        {menuItems.map((item) => (
          <NavItem key={item.id}>
            <a href={`#${item.path}`}>{item.content}</a>
          </NavItem>
        ))}
      </MenuContainer>
      <LoginButtonHeader>
        <a href={env.REACT_APP_PANEL_REDIRECT}>
          <CustomButton width="140px" height="40px">
            ورود به حساب
          </CustomButton>
        </a>
      </LoginButtonHeader>
    </Header>
  );
};

export default LandingHeader;
